import { Box, Loader, Text } from '@acast/decibel';
import removeFromCollection from 'app/collection/actions/remove';
import deleteEntity from 'app/entity/actions/delete';
import { trackOperation } from 'app/operations';
import store from 'app/store';
import React from 'react';
import { Episode, ShowDrafts, ShowEpisodes } from 'resources';
import Modal from 'shared/components/modal';
import navigateTo from 'shared/helpers/navigate-to';

const DeletePendingDialog = () => {
  return (
    <Box gap={6} alignItems="center" justifyContent="center" height={25}>
      <Loader width={8} />
      <Text mb={0}>Your episode is being deleted...</Text>
    </Box>
  );
};

const DELETING_EPISODE_PENDING_MODAL = {
  dialog: <DeletePendingDialog />,
  actions: [],
  onDismiss: () => {},
};

const DELETE_EPISODE_ERROR_MODAL = {
  title: 'Operation failed',
  dialog: 'Unable to delete episode.',
  actions: Modal.Actions.OK,
};

function presentDeletePendingModal(options) {
  Modal.present({ ...DELETING_EPISODE_PENDING_MODAL, ...options });
}

function presentDeleteFailedModal(options) {
  Modal.present({ ...DELETE_EPISODE_ERROR_MODAL, ...options });
}

function runDeleteEpisode(episode) {
  const { show } = episode;
  return new Promise((resolve, reject) => {
    deleteEntity(Episode, episode)
      .then(() => {
        const collection = episode.isDraft ? ShowDrafts : ShowEpisodes;
        return removeFromCollection(collection, show, [episode]);
      })
      .then(resolve)
      .catch(reject);
  });
}

export default episode => {
  const deleteOperationId = `${episode.id}/delete`;
  const showId = episode.show;

  presentDeletePendingModal({
    id: deleteOperationId,
  });

  store
    .dispatch(trackOperation(runDeleteEpisode(episode), deleteOperationId))
    .then(() => {
      Modal.dismiss(deleteOperationId);
      navigateTo(`/shows/${showId}`);
    })
    .catch(err => {
      // eslint-disable-next-line
      console.error(err);
      Modal.dismiss(deleteOperationId);
      presentDeleteFailedModal({
        dialog: (
          <Text mb={0}>
            Failed to delete episode.
            <br />
            <br />
            <b>Reason:</b> {err.message}
          </Text>
        ),
      });
    });
};
